/**
 * GMA-1621 (CompassCare Web 6/14) — Operational map route container.
 *
 * Mounts the app-shell (WebShell) around the operational map at /web/map,
 * wiring sidebar navigation to the router. The map itself — live pins, IPAWS
 * zones, corridors, coverage note — lives in ClientsMapPanel (#685), which
 * the caregiver homepage also embeds shell-less.
 *
 * GMA-1995: elopement boundary draw is enabled only on this Command Center
 * route (never on the caregiver homepage embed), and only when the
 * commandcenter build sets REACT_APP_FEATURE_FLAG_ELOPEMENT_BOUNDARY_ENABLED.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import WebShell from "../../components/web/WebShell";
import ClientsMapPanel from "./ClientsMapPanel";

export default function WebMapRoute() {
  const navigate = useNavigate();
  return (
    <WebShell
      activeKey="map"
      onNavigate={(section) => {
        if (section && section.path) navigate(section.path);
      }}
      title="Map"
    >
      <ClientsMapPanel enableElopementBoundary />
    </WebShell>
  );
}
